import { Link } from "gatsby";
import parse from "html-react-parser";
import React from "react";
import { chevronRight } from "../../assets/images/icons";
import contentParserOptions from "../../utils/parser";
import "./searchResults.scss";
import "./searchResults.scss";
import { createRedirectURL } from "../../utils/helperFunctions";
import { ingestData } from "../../bridges/BridgeServices";
import { EVENTS } from "../../utils/constants";

const SearchedItem = ({ node }) => {
  const {
    searchedValueStart,
    searchedValueEnd,
    item,
    highlight,
  } = node || {};
  const title = item?.title;
  const description = item?.description;

  const uri = item?.uri;

  let formattedTitle = title;

  if (highlight && searchedValueStart >= 0) {
    formattedTitle = (
      <>
        {title?.substring(0, searchedValueStart)}
        <span className="highlight">
          {title?.substring(
            searchedValueStart,
            searchedValueEnd + 1
          )}
        </span>
        {title?.substring(searchedValueEnd + 1)}
      </>
    );
  }
  return (
    <Link
      to={createRedirectURL(uri)}
      className="search-results"
      onClick={() => {
        ingestData({
          name: EVENTS.FAQ_SEARCH_RESULT_CLICKED,
          data: {
            faqTitle: title,
          },
        });
      }}
    >
      {formattedTitle && (
        <div className="search-results-heading-wrapper">
          <p className="search-results-heading">
            {formattedTitle}
          </p>
          {parse(chevronRight)}
        </div>
      )}
      {description && (
        <p className="search-results-subtitle">
          {parse(description, contentParserOptions)}
        </p>
      )}
    </Link>
  );
};

export default SearchedItem;
